import angular from 'angular';
import uiRouter from 'angular-ui-router';
import homeComponent from './home.component';

let homeModule = angular.module('home', [
  uiRouter
])

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";

  $urlRouterProvider.otherwise('');

  $stateProvider
    .state('home', {
      url: '',
      template: '<home></home>'
    })
    /*.state('home.landing', {
      url: '/',
      template: '<landingpage></landingpage>',
      redirectTo: 'home.landingpage.viewpaybilllanding'
    })*/
    .state('home.landingpage', {
      url: '/landingpage',
      template: '<landingpage></landingpage>',
      params: {
        home_id: undefined,
        plant_id: undefined,
        casn: undefined,
        option: undefined
      }//,
      //redirectTo: 'home.landingpage.viewpaybilllanding'
    })
    .state('home.landingpage.viewpaybilllanding', {
      url: '/viewpaybilllanding',
      template: '<viewpaybilllanding></viewpaybilllanding>'
    })
    .state('home.landingpage.videobilllanding', {
      url: '/videobilllanding',
      template: '<videobilllanding></videobilllanding>'
    })
    .state('home.landingpage.paperlessbillinglanding', {
      url: '/paperlessbillinglanding',
      template: '<paperlessbillinglanding></paperlessbillinglanding>'
    })
    .state('home.landingpage.optimumidslanding', {
      url: '/optimumidslanding',
      template: '<optimumidslanding></optimumidslanding>'
    })
    .state('home.landingpage.tutorialslanding', {
      url: '/tutorialslanding',
      template: '<tutorialslanding></tutorialslanding>'
    })
    .state('home.landingpage.faqlanding', {
      url: '/faqlanding',
       template: '<faqlanding></faqlanding>'
    })
    .state('home.landingpage.suddenlinkidslanding', {
      url: '/suddenlinkidslanding',
      template: '<suddenlinkidslanding></suddenlinkidslanding>'
    })
    .state('home.viewpaybill', {
      url: '/viewpaybill',
      template: '<viewpaybill></viewpaybill>'
    })
    .state('home.paperlessbilling', {
      url: '/paperlessbilling',
      template: '<paperlessbilling></paperlessbilling>'
    })
    .state('home.keyboard', {
      url: '/keyboard',
      template: '<keyboard></keyboard>'
    })
    .state('home.optimumids', {
    url: '/optimumids',
    template: '<optimumids></optimumids>'
    })
    .state('home.suddenlinkids', {
      url: '/suddenlinkids',
      template: '<suddenlinkids></suddenlinkids>'
    })
    .state('home.tutorials', {
    url: '/tutorials',
    template: '<tutorials></tutorials>'
    })
    .state('home.faq', {
    url: '/faq',
    template: '<faq></faq>'
    })
    .state('home.faqtemplate', {
    url: '/faqtemplate',
    template: '<faqtemplate></faqtemplate>'
  });
})

.run(['$state', function ($state) {
  $state.transitionTo('home.landingpage');
}])

.component('home', homeComponent);

export default homeModule;



// WEBPACK FOOTER //
// ./client/app/components/home/home.js